function normalizeBaseUrl(value: string): string {
  return value.replace(/\/+$/, "");
}

export const runtime = Object.freeze({
  accountApiUrl: normalizeBaseUrl(
    import.meta.env.VITE_ACCOUNT_API_URL ??
      "https://account.bizconnectpay.com/api/v1",
  ),
  publicApiUrl: normalizeBaseUrl(
    import.meta.env.VITE_PUBLIC_API_URL ??
      "https://api.bizconnectpay.com/api/v1",
  ),
  merchantAssistantSocketUrl:
    import.meta.env.VITE_MERCHANT_ASSISTANT_SOCKET_URL ??
    new URL(
      import.meta.env.VITE_PUBLIC_API_URL ??
        "https://api.bizconnectpay.com/api/v1",
    ).origin,
});
